// English
export const EN = {
  'locale': 'en',
  'email-required': 'We need your email!',
  'email-valid': 'We need a valid email !',
  'contact-email-label': 'email',
  'done': 'done!',
  'delete': 'delete',
  'by': 'by',
  'made-with': 'made with',
  'menu-pages': '../../static/menu_en/'
};

// Spanish
export const ES = {
  'locale': 'es',
  'email-required': '¡Necesitamos su email!',
  'email-valid': '¡Necesitamos un email válido!',
  'contact-email-label': 'email',
  'done': '¡listo!',
  'delete': 'eliminar',
  'by': 'por',
  'made-with': 'hecho con',
  'menu-pages': '../../static/menu_es/'
};

// French
export const FR = {
  'locale': 'fr',
  'menu-pages': '../../static/menu_en/'
};

// Dutch
export const NL = {
  'locale': 'nl',
  'menu-pages': '../../static/menu_en/'
};


// Portuguese
export const PT = {
  'locale': 'pt',
  'menu-pages': '../../static/menu_en/'
};

// German
export const DE = {
  'locale': 'de',
  'menu-pages': '../../static/menu_en/'
};

// Italian
export const IT = {
  'locale': 'it',
  'menu-pages': '../../static/menu_en/'
};


// Arabic
export const AR = {
  'locale': 'ar',
  'menu-pages': '../../static/menu_en/'
};

// Chinese
export const ZH = {
  'locale': 'zh',
  'menu-pages': '../../static/menu_en/'
};


// WEBPACK FOOTER //
// ./src/messages/sharedMessages.js